import { createReducer } from "typesafe-actions";

import { ContractorDashboardState as DashboardState } from "../../../types";
import { Actions } from "../../../store/epics";
import {
  getContrctorDashboardAction,

} from "./actions";




const initialState: DashboardState = {
  Delivered: 0,
  Rejected: 0,
  Pending: 0,
  Accepted: 0,
  errorMessage: "",
  loading: false,
  prescriptions: [],
  scheduledInvites: []
};

export default createReducer<DashboardState, Actions>(initialState)
  .handleAction(getContrctorDashboardAction.request, (state) => {
    return {
      ...state,
      loading: true,
    };
  })
  .handleAction(
    [getContrctorDashboardAction.success, getContrctorDashboardAction.failure],
    (state, { payload }) => {
      return {
        ...state,
        loading: false,
        Delivered: payload.Delivered || state.Delivered,
        Rejected: payload.Rejected || state.Rejected,
        Pending: payload.Pending || state.Pending,
        Accepted: payload.Accepted || state.Accepted,
      };
});
